/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import { css } from '@emotion/react';
import { useSelector } from 'react-redux';

import { PropagateLoader } from 'react-spinners';

import styles from 'src/app/components/ProgressSpinner/ProgressSpinner.module.scss';
import { GameState } from 'src/enums/game-state.enum';
import { reduxRootTypes } from 'src/types';

const LoadingSpinner: React.FC = () => {
  const override = css`
    display: block;
    margin: 0 auto;
    border-color: red;
  `;

  const { eventState } = useSelector((state: reduxRootTypes.RootStateType) => state.eventState);

  return (
    <>
      {eventState === GameState.Loading && (
        <div className="loading_spinner">
          <PropagateLoader color="var(--ete-primary-green-color)" loading css={override} size={30} />
        </div>
      )}
    </>
  );
};

export default LoadingSpinner;
